
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSpeciesForms, GetSpeciesFormsResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetSpeciesFormsResponse, GetSpeciesFormsResponse>) => response?.data?.speciesForms;
const getError = (response?: SWRResponse<GetSpeciesFormsResponse, GetSpeciesFormsResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetSpeciesFormsResponse, GetSpeciesFormsResponse>) => ({});

const useGetSpeciesForms = (query?: Partial<GetSpeciesForms>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetSpeciesForms(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSpeciesForms;